<template>
  <div style="background-color: #F4F7FE; min-height: 100vh;" class="pa-6">
    <v-row class="mb-6 px-4" align="center">
      <v-col cols="12" md="6">
        <h2 class="text-h4 font-weight-black" style="color: #1B2559;">Gestión de Pagos</h2>
        <div class="d-flex align-center mt-1">
          <v-icon small color="#A3AED0" class="mr-2">mdi-cash-check</v-icon>
          <span class="text-subtitle-2 font-weight-bold" style="color: #A3AED0;">
            Historial financiero detallado de LIVE FIT
          </span>
        </div>
      </v-col>
      <v-col cols="12" md="6" class="d-flex justify-md-end">
        <periodo-busqueda @buscar="onBuscar" />
      </v-col>
    </v-row>

    <v-row class="mb-8">
      <v-col cols="12" md="4">
        <v-card class="rounded-xl pa-6 elevation-1 border-0" color="#4318FF" dark>
          <div class="d-flex align-center">
            <v-btn fab color="rgba(255,255,255,0.2)" depressed class="mr-4">
              <v-icon large>mdi-currency-usd</v-icon>
            </v-btn>
            <div>
              <div class="text-overline white--text" style="opacity: 0.8">Total en Periodo</div>
              <div class="text-h4 font-weight-black">S/ {{ totalPagos }}</div>
            </div>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" md="8">
        <v-card class="rounded-xl pa-6 elevation-1 border-0 d-flex align-center justify-space-around" height="100%">
          <div v-for="(m, i) in totalesMembresias.slice(0, 3)" :key="i" class="text-center">
            <div class="caption grey--text font-weight-black text-uppercase">{{ m.nombre }}</div>
            <div class="text-h6 font-weight-black" style="color: #1B2559;">S/ {{ m.total }}</div>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <v-card class="rounded-xl elevation-1 border-0 pa-4 mb-10">
      <v-card-title class="px-4">
        <span class="text-h6 font-weight-bold" style="color: #1B2559;">Listado de Transacciones</span>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="busqueda"
          append-icon="mdi-magnify"
          label="Buscar pago o miembro..."
          solo-inverted
          flat
          hide-details
          class="rounded-lg"
          style="max-width: 350px"
        ></v-text-field>
      </v-card-title>

      <v-data-table
        :loading="cargando"
        :headers="encabezadoTabla"
        :items="pagos"
        :search="busqueda"
        class="mt-4"
        :footer-props="{itemsPerPageText: 'Filas por página'}"
      >
        <template v-slot:[`item.imagen`]="{ item }">
          <v-avatar size="36" class="list-avatar elevation-1">
            <img :src="urlImagen(item.imagen)" />
          </v-avatar>
        </template>

        <template v-slot:[`item.monto`]="{ item }">
          <span class="font-weight-black green--text text--darken-2">S/ {{ item.monto }}</span>
        </template>

        <template v-slot:[`item.membresia`]="{ item }">
          <v-chip small :color="item.membresia.includes('VISITA') ? '#A3AED0' : '#4318FF'" dark class="font-weight-bold">
            {{ item.membresia }}
          </v-chip>
        </template>

        <template v-slot:[`item.acciones`]="{ item }">
          <v-btn icon class="action-primary" @click="verPago(item)"><v-icon>mdi-eye-outline</v-icon></v-btn>
          <v-btn icon class="action-danger" @click="confirmarAnular(item)"><v-icon>mdi-cancel</v-icon></v-btn>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="mostrarDialogoAdmin" max-width="520">
      <dialogo-confirm-admin @confirmar="onConfirmAdmin" @cancelar="mostrarDialogoAdmin = false" />
    </v-dialog>

    <v-row>
      <v-col cols="12" md="6">
        <div class="d-flex align-center mb-4">
          <v-icon color="#1B2559" class="mr-2">mdi-account-tie</v-icon>
          <h3 class="text-h5 font-weight-black" style="color: #1B2559;">Recaudación por Recepcionista</h3>
        </div>
        <v-row>
          <v-col v-for="(u, idx) in totalesUsuarios" :key="idx" cols="12" sm="6">
            <v-card class="rounded-xl pa-4 elevation-1 d-flex align-center border-0">
              <v-avatar color="#F4F7FE" size="50" class="mr-4">
                <v-icon color="#4318FF">mdi-account-cash</v-icon>
              </v-avatar>
              <div>
                <div class="caption grey--text font-weight-bold text-uppercase">{{ u.nombre }}</div>
                <div class="text-h6 font-weight-black" style="color: #1B2559;">S/ {{ u.total }}</div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" md="6">
        <div class="d-flex align-center mb-4">
          <v-icon color="#1B2559" class="mr-2">mdi-star-circle</v-icon>
          <h3 class="text-h5 font-weight-black" style="color: #1B2559;">Top Miembros (Fidelidad)</h3>
        </div>
        <v-row>
          <v-col v-for="(s, sIdx) in totalesMiembros" :key="sIdx" cols="12" sm="6">
            <v-card class="rounded-xl pa-4 elevation-1 d-flex align-center border-0">
              <v-avatar size="50" class="mr-4">
                <img :src="s.imagen ? urlImagen(s.imagen) : 'https://cdn-icons-png.flaticon.com/512/149/149071.png'">
              </v-avatar>
              <div>
                <div class="caption grey--text font-weight-bold">{{ s.nombre }}</div>
                <div class="text-h6 font-weight-black" style="color: #05CD99;">S/ {{ s.total }}</div>
                <v-rating :value="5" color="amber" dense half-increments readonly size="14"></v-rating>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-overlay :value="cargando" color="#1B2559" opacity="0.8">
      <div class="text-center">
        <v-progress-circular indeterminate size="64" color="#4318FF" width="6"></v-progress-circular>
        <div class="mt-4 white--text font-weight-bold text-uppercase">Actualizando Finanzas...</div>
      </div>
    </v-overlay>
  </div>
</template>

<script>
import HttpService from '../../Servicios/HttpService'
import Utiles from '../../Servicios/Utiles'
import PeriodoBusqueda from '../Dialogos/PeriodoBusqueda.vue'
import DialogoConfirmAdmin from '../Dialogos/DialogoConfirmAdmin.vue'

export default {
    name: "PagosPremium",
    components: { PeriodoBusqueda, DialogoConfirmAdmin },
    data:()=>({
        busqueda: "",
        cargando: false,
        pagos: [],
        totalPagos: 0,
        totalesMembresias: [],
        totalesUsuarios: [],
        totalesMiembros: [],
        filtros: {
            fechaInicio: null,
            fechaFin: null
        },
        encabezadoTabla: [
            {text: "Foto", value: "imagen", sortable: false, width: "80px"},
            {text: "Miembro", value: "nombre", fontClass: "font-weight-bold"},
            {text: "Matrícula", value: "matricula"},
            {text: "Fecha / Hora", value: "fecha"},
            {text: "Monto Pagado", value: "monto"},
            {text: "Plan Adquirido", value: "membresia"},
            {text: "Atendido por", value: "usuario"},
            {text: "Acciones", value: "acciones"},
        ],
        mostrarDialogoAdmin: false,
        pagoSeleccionado: null,
    }),

    mounted(){
        this.obtenerPagos()
    },

    methods: {
        onBuscar(fechas){
            this.filtros = {
                fechaInicio: fechas[0],
                fechaFin: fechas[1]
            }
            this.obtenerPagos()
        },

        urlImagen(imagen){
            return Utiles.generarURL(imagen, 'miembros')
        },

        obtenerPagos(){
            this.cargando = true
            let payload = { 
                metodo: 'obtener',
                filtros: this.filtros
            }
            HttpService.obtenerConDatos(payload, 'pagos.php')
            .then(respuesta => {
                this.pagos = respuesta.pagos || []
                this.totalPagos = respuesta.totalPagos || 0
                this.totalesMembresias = respuesta.totalesMembresias || []
                this.totalesUsuarios = respuesta.totalesUsuario || []
                this.totalesMiembros = respuesta.totalesMiembros || []
                this.cargando = false
            })
            .catch(err => {
                console.error("Error en pagos:", err)
                this.cargando = false
            })
        },

        verPago(item) {
            alert(`Pago: ${item.matricula}\nMonto: S/ ${item.monto}\nFecha: ${item.fecha}`);
        },

        confirmarAnular(item) {
            this.pagoSeleccionado = item;
            this.mostrarDialogoAdmin = true;
        },

        async onConfirmAdmin(creds) {
            this.cargando = true;
            try {
                // verificar credenciales admin
                const ver = await HttpService.obtenerConDatos({ metodo: "verificar_admin", usuario: creds.usuario, password: creds.password }, "usuarios.php");
                if (ver && ver.resultado) {
                    // llamar anular con id del admin y motivo
                    const res = await HttpService.obtenerConDatos({ metodo: "anular", id: this.pagoSeleccionado.id, usuario: ver.id, motivo: creds.motivo }, "pagos.php");
                    if (res && (res.resultado === true || res.resultado)) {
                        this.mensaje = { texto: res.mensaje || "Pago anulado", color: "success" };
                        this.mostrarMensaje = true;
                        this.mostrarDialogoAdmin = false;
                        this.obtenerPagos();
                    } else {
                        this.mensaje = { texto: res.mensaje || "No se pudo anular", color: "error" };
                        this.mostrarMensaje = true;
                    }
                } else {
                    this.mensaje = { texto: "Credenciales inválidas", color: "error" };
                    this.mostrarMensaje = true;
                }
            } catch(e) {
                console.error(e);
                this.mensaje = { texto: "Error de conexión", color: "error" };
                this.mostrarMensaje = true;
            } finally { this.cargando = false; }
        }
    }
}
</script>

<style scoped>
.v-card {
  transition: all 0.3s ease-in-out;
}
.v-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 20px rgba(0,0,0,0.1) !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Pagos/Pagos.vue